export const FeedCategoryTxn = {
  recentlySold: 'Recently Sold',
  recentPriceDrop: 'Price Drop'
}
